var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80628 0.000976562C3.50097 0.000976562 0.000854492 3.50109 0.000854492 7.8064C0.000854492 12.1117 3.50097 15.6118 7.80628 15.6118C12.1116 15.6118 15.6117 12.1117 15.6117 7.8064C15.6117 3.50109 12.1116 0.000976562 7.80628 0.000976562ZM7.80628 14.0672C4.61838 14.0672 1.97275 11.668 1.5948 8.57873H8.64433L6.90252 10.3369C6.6068 10.6327 6.6068 11.1257 6.90252 11.4215C7.05039 11.5694 7.24766 11.6516 7.44479 11.6516C7.64192 11.6516 7.8392 11.5694 7.98707 11.4215L11.0599 8.34864C11.3557 8.05292 11.3557 7.55991 11.0599 7.26407L7.98707 4.1912C7.69134 3.89547 7.19834 3.89547 6.90249 4.1912C6.60677 4.48692 6.60677 4.97993 6.90249 5.27577L8.66083 7.0341L1.59486 7.03399C1.97278 3.94468 4.61844 1.54554 7.80634 1.54554C11.2572 1.54554 14.0671 4.35544 14.0671 7.80632C14.0671 11.2572 11.2572 14.0671 7.80634 14.0671L7.80628 14.0672Z",
    fill: "url(#paint0_linear_230_947)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_230_947",
    x1: 7.80628,
    y1: 0.000976562,
    x2: 7.80628,
    y2: 15.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowRight);
export default __webpack_public_path__ + "static/media/blue-arrow-right.6e10073ed7889822ae6ef7ce0a58c6cc.svg";
export { ForwardRef as ReactComponent };